export const APPROVED_APPLICATIONS_SECTION = {
    TITLE: 'Solicitudes aprobadas',
    SUBTITLE: 'Listado de solicitudes aprobadas por backoffice con el banco de cierre asignado desde el módulo de crédito.',
};

export const SUMMARY_TABLE = {
    FINANCIERA: 'Financiera',
    APROBADO: 'Aprobado',
    CONDICIONADO: 'Condicionado',
    RECHAZADO: 'Rechazado',
    SIN_PROCESO: 'Sin proceso',
    HOY: 'Hoy',
};

export const LIST_TABLE = {
    FECHA: 'Fecha',
    CLIENTE: 'Cliente',
    CONSECUTIVO: 'Consecutivo',
    ANALISTA_BACK: 'Analista Back',
    ASESOR_DE_CAMPO: 'Asesor de Campo',
    DEALER: 'Dealer',
    CELULA: 'Célula',
    COPPEL: 'Coppel',
    CREDITAS: 'Creditas',
    RAPIDAUTO: 'Rapidauto',
    COMENTARIOS: 'Comentarios',
    COMENTARIO_COMERCIAL: 'Comentario Comercial',
    TIPIFICACION: 'Tipificación',
    COMPRA: 'Compra',
    TASA: 'Tasa',
    PLAZO: 'Plazo',
    ENGANCHE_INICIAL: 'Enganche inicial',
    ENGANCHE_APROBADO: 'Enganche aprobado',
    ACCIONES: 'Acciones',
    EDIT: 'Editar',
    EMPTY_VALUE: '-',
    EMPTY_MESSAGE_FILTERED: 'No se encontraron solicitudes aprobadas con ese criterio de búsqueda o filtros.',
    EMPTY_MESSAGE_DEFAULT: 'No hay solicitudes aprobadas en proceso por el momento.',
};

export const showingFooterText = (shown: number, total: number): string =>
    `Mostrando ${shown} de ${total} solicitudes aprobadas`;

export const SEARCH_FILTERS = {
    SEARCH_PLACEHOLDER: 'Buscar por cliente, consecutivo, asesor de campo, dealer o célula',
    FINANCIERA_PLACEHOLDER: 'Todas las financieras',
    STATUS_PLACEHOLDER: 'Todos los estatus',
    EXPORT_BUTTON_LABEL: 'Exportar a Excel',
    EXPORT_BUTTON_GENERATING_LABEL: 'Generando…',
    EXPORT_DISABLED_MESSAGE: 'La exportación a Excel se deshabilita cuando existe una búsqueda o filtro aplicado. '
        + 'Limpia el buscador y restablece los filtros para habilitarla.',
};

export const EXPORT_VOLUME_LIMIT = 500;

export const EXPORT_MODAL = {
    CONFIRM_TITLE: 'Exportar a Excel',
    CONFIRM_TEXT: '¿Deseas exportar el listado completo de solicitudes aprobadas a un archivo Excel?',
    CONFIRM_CANCEL_BUTTON: 'Cancelar',
    CONFIRM_ACCEPT_BUTTON: 'Exportar a Excel',
    GENERATING_TEXT: 'Generando el archivo…',
    successText: (fileName: string): string => `El archivo "${fileName}" se generó correctamente.`,
    DOWNLOAD_BUTTON: 'Descargar archivo',
    CLOSE_BUTTON: 'Cerrar',
    ERROR_TEXT: 'Ocurrió un error al generar el archivo. Intenta de nuevo.',
    VOLUME_TITLE: 'Exportación con gran volumen de datos',
    volumeText: (total: number): string =>
        `Se detectaron ${total} solicitudes aprobadas, más de las 500 permitidas para una exportación `
        + 'automática. Este proceso podría volver lento el sistema.',
    VOLUME_SUBTEXT: 'La exportación de este volumen se activará de forma manual, generando un archivo por cada '
        + 'página de 40 registros.',
    VOLUME_ACCEPT_BUTTON: 'Entendido',
};

export const HISTORY_EXPORT_MODAL = {
    CONFIRM_TITLE: 'Exportar historial',
    CONFIRM_TEXT: '¿Deseas exportar el historial de solicitudes aprobadas correspondiente al período '
        + 'seleccionado a un archivo Excel?',
    CONFIRM_CANCEL_BUTTON: EXPORT_MODAL.CONFIRM_CANCEL_BUTTON,
    CONFIRM_ACCEPT_BUTTON: 'Exportar historial',
    GENERATING_TEXT: EXPORT_MODAL.GENERATING_TEXT,
    successText: EXPORT_MODAL.successText,
    DOWNLOAD_BUTTON: EXPORT_MODAL.DOWNLOAD_BUTTON,
    CLOSE_BUTTON: EXPORT_MODAL.CLOSE_BUTTON,
    ERROR_TEXT: EXPORT_MODAL.ERROR_TEXT,
    VOLUME_TITLE: EXPORT_MODAL.VOLUME_TITLE,
    volumeText: EXPORT_MODAL.volumeText,
    VOLUME_SUBTEXT: EXPORT_MODAL.VOLUME_SUBTEXT,
    VOLUME_ACCEPT_BUTTON: EXPORT_MODAL.VOLUME_ACCEPT_BUTTON,
};

export const FINANCIERA_FILTER_OPTIONS = [
    {id: '', value: 'Todas las financieras', payload: ''},
    {id: 'COPPEL', value: 'Coppel', payload: ''},
    {id: 'CREDITAS', value: 'Creditas', payload: ''},
    {id: 'RAPIDAUTO', value: 'Rapidauto', payload: ''},
];

export const STATUS_FILTER_OPTIONS = [
    {id: '', value: 'Todos los estatus', payload: ''},
    {id: 'CURRENT', value: 'Vigente', payload: ''},
    {id: 'EXPIRING', value: 'Por vencer', payload: ''},
    {id: 'EXPIRED', value: 'Vencida', payload: ''},
];

export const HISTORY_FILTERS = {
    DATE_FROM_LABEL: 'Fecha de aprobación Desde',
    DATE_TO_LABEL: 'Fecha de aprobación Hasta',
    FILTER_DATES_ERROR: 'El período seleccionado es incorrecto.',
    EXPORT_BUTTON_LABEL: 'Exportar historial',
    filenamePreviewText: (fileName: string): string =>
        `El archivo se titulará ${fileName}, según el período seleccionado`,
};

export const HISTORY_TABLE = {
    EMPTY_MESSAGE: 'No se encontraron resultados…',
};
